import Vue from 'vue'
import Vuex from 'vuex'
import { detectLang } from '@/lang/langs'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 接口根地址。
    // 生产默认走 api.aitaoify.com；本地预览用 preview_local.py 做了同源反代
    // （/Admin /Manager /Api 转发到 127.0.0.1:8088），
    // 构建时传 VUE_APP_BASEURL=same-origin 即可切到同源，避免跨域。
    baseUrl: (process.env.VUE_APP_BASEURL === 'same-origin'
      ? ''
      : (process.env.VUE_APP_BASEURL || 'https://api.aitaoify.com')),
 //  baseUrl:'http://192.168.31.139:85',
  // baseUrl:'http://192.168.0.194:85',
    langdef: detectLang(),
    USERINFO:JSON.parse(localStorage.getItem("DROPSHOPUSERINFO"))?JSON.parse(localStorage.getItem("DROPSHOPUSERINFO")):null,
    locationOrigin:location.origin,
    shop_web_domain:localStorage.getItem("shop_web_domain")?localStorage.getItem("shop_web_domain"):'',//header传值使用
    defaultShopid:localStorage.getItem("defaultShopid")?localStorage.getItem("defaultShopid"):'',//当前shopid header传值使用
  },
  mutations: {
    setLangDef(state,langdef){
      state.langdef = langdef
      localStorage.setItem('langdef',langdef)
    },
    setUSERINFO(state,data){
      localStorage.setItem('DROPSHOPUSERINFO',JSON.stringify(data))
      state.USERINFO=JSON.parse(localStorage.getItem("DROPSHOPUSERINFO"))
    },
  },
})
